var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.083c1.519 0 2.75-1.195 2.75-2.669V2.67C11.25 1.195 10.019 0 8.5 0S5.75 1.195 5.75 2.67v4.744c0 1.474 1.231 2.67 2.75 2.67zM7.278 2.67c0-.654.548-1.186 1.222-1.186.674 0 1.222.532 1.222 1.186v4.745c0 .654-.548 1.186-1.222 1.186-.674 0-1.222-.532-1.222-1.186V2.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7.333h-1.447c0 2.36-1.818 4.278-4.053 4.278S4.447 9.692 4.447 7.333H3c0 2.942 2.085 5.374 4.776 5.75v.973h-2.46v1.527h6.368v-1.527h-2.46v-.973c2.69-.376 4.776-2.808 4.776-5.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.e4fb69256b315ac0777263c2b38db255.svg";
export { ForwardRef as ReactComponent };